import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const filters = {
    categoryId: "",
    sort: "",
    contentType: "",
    text: "",
};
const initialState = {
    isLoading: false,
    error: null,
    categorieslist: [],
    rootcategorieslist: [],

    currentPage: 0,
    limit: 8,
    totalalbums: 0,
    product: null,
    productbanner: null,
    Languages: null,
    Filters: filters,
};

export const getAllCategories = createAsyncThunk(
    "categories/get_categories",
    async (_, { dispatch, getState, rejectWithValue }) => {

        try {
            dispatch(getallcategoriesStart());
            const response = await axios.get(
                `categories/get_active_categories.php`
            );
            dispatch(getallcategoriesSuccess(response?.data));
            return response?.data;
        } catch (error) {
            const msg = error?.response?.data?.message || error?.message || "Failed to load categories";
            dispatch(getallcategoriesfailure(msg));
            return rejectWithValue(msg);
        }
    }
);
export const getAllRootCategories = createAsyncThunk(
    "categories/get_active_root_categories",
    async (_, { dispatch, getState, rejectWithValue }) => {

        try {
            dispatch(getallrootcategoriesStart());
            const response = await axios.get(
                `categories/get_active_root_categories.php`
            );
            dispatch(getallrootcategoriesSuccess(response?.data));
            return response?.data;
        } catch (error) {
            const msg = error?.response?.data?.message || error?.message || "Failed to load root categories";
            dispatch(getallrootcategoriesfailure(msg));
            return rejectWithValue(msg);
        }
    }
);

export const getSingleProduct = createAsyncThunk(
    "product/singleproduct",
    async (slug, { dispatch, getState, rejectWithValue }) => {
        try {
            dispatch(getsingleproductStart());
            const response = await axios.get(`product/${slug}`);
            dispatch(getsingleproductSuccess(response?.data));
            return response?.data;
        } catch (error) {
            const msg = error?.response?.data?.message || error?.message || "Failed to load product";
            dispatch(getsingleproductfailure(msg));
            return rejectWithValue(msg);
        }
    }
);

export const getProductBanner = createAsyncThunk(
    "config/get_productbanner",
    async (_, { dispatch, getState, rejectWithValue }) => {
        try {
            dispatch(getproductbannerStart());
            const response = await axios.get(`config/get_productbanner`);
            dispatch(getproductbannerSuccess(response?.data));
            return response?.data;
        } catch (error) {
            const msg = error?.response?.data?.message || error?.message || "Failed to load banner";
            dispatch(getproductbannerfailure(msg));
            return rejectWithValue(msg);
        }
    }
);

export const getProductCategory = createAsyncThunk(
    "product/getProductCategory",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(getallproductCategoryStart());
            const response = await axios.get(`product/productcategory_all`);
            dispatch(
                getallproductCategorySuccess(response?.data?.allproductcategories)
            );
            return response?.data?.allproductcategories;
        } catch (error) {
            const msg = error?.response?.data?.message || error?.message || "Failed to load category";
            dispatch(getallproductCategoryfailure(msg));
            return rejectWithValue(msg);
        }
    }
);


const categoriesSlice = createSlice({
    name: "categories",
    initialState,
    reducers: {
        getallcategoriesStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getallcategoriesSuccess(state, action) {
            state.isLoading = false;

            state.categorieslist = action.payload?.data;

        },
        getallcategoriesfailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },
        getallrootcategoriesStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getallrootcategoriesSuccess(state, action) {
            state.isLoading = false;

            state.rootcategorieslist = action.payload?.data;

        },
        getallrootcategoriesfailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },
        getsinglecategoriesStart(state, action) {
            state.isLoading = true;
            state.error = null;
        },
        getsingleproductSuccess(state, action) {
            state.isLoading = false;
            state.product = action.payload?.product;
        },
        getsingleproductfailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },
        getproductbannerStart(state, action) {
            state.isLoading = true;
            state.error = false;
        },
        getproductbannerSuccess(state, action) {
            state.isLoading = false;
            state.productbanner = action.payload;
        },
        getproductbannerfailure(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getallproductCategoryStart(state) {
            state.isLoading = true;
            state.error = null;
            state.productCategoryList = [];
        },
        getallproductCategorySuccess(state, action) {
            state.isLoading = false;
            state.productCategoryList = action.payload;
        },
        getallproductCategoryfailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },

        filtersUpdate(state, action) {
            const { categoryId, sort, contentType, text } = action.payload;
            if (categoryId !== undefined) {
                state.Filters.categoryId = categoryId;
            }

            if (sort !== undefined) {
                state.Filters.sort = sort;
            }
            if (contentType !== undefined) {
                state.Filters.contentType = contentType;
            }
            if (text !== undefined) {
                state.Filters.text = text;
            }
        },
    },
});

export const {
    filtersUpdate,
    getallcategoriesStart,
    getallcategoriesSuccess,
    getallcategoriesfailure,
    getallrootcategoriesStart,
    getallrootcategoriesSuccess,
    getallrootcategoriesfailure,
    getsingleproductStart,
    getsingleproductSuccess,
    getsingleproductfailure,
    getproductbannerStart,
    getproductbannerSuccess,
    getproductbannerfailure,
    getallproductCategoryStart,
    getallproductCategorySuccess,
    getallproductCategoryfailure,

} = categoriesSlice.actions;

export default categoriesSlice.reducer;
